import { combineReducers } from "@reduxjs/toolkit";

import type { StakeholderAction } from "entities/stakeholders/actionTypes";
import { StakeholderActionTypes } from "entities/stakeholders/actionTypes";
import type { StakeholderState } from "entities/stakeholders/types";

const initialState: StakeholderState = { byId: {} };

const byId = (state = initialState.byId, action: StakeholderAction): StakeholderState["byId"] => {
  switch (action.type) {
    case StakeholderActionTypes.FETCH_FOR_TOPIC_SUCCESS: {
      return action.payload.data.reduce(
        (accumulator, next) => ({ ...accumulator, [next.id]: { ...state[next.id], ...next } }),
        state,
      );
    }
    case StakeholderActionTypes.FETCH_FOR_ID_SUCCESS: {
      const { roles: _roles, ...stakeholder } = action.payload;
      return {
        ...state,
        [action.meta.id]: {
          ...state[action.meta.id],
          ...stakeholder,
        },
      };
    }
    default:
      return state;
  }
};

export const stakeholdersReducer = combineReducers({
  byId,
});
